
import store from './index'
export const dispatchLogin = (products: any) => {
  return store.dispatch('account/login', products)
}
export const dispatchLogOut = () => {
  return store.dispatch('account/logOut')
}
